import icon from "url:../../svg/symbol-defs.svg";

class search {
  parentEl = document.querySelector(".search__overlay");
  searchInput = document.querySelector("#search");
  resultMess;
  resultNum;
  searchMessage = document.querySelector(".search__message");
  spinnerCon = document.querySelector(".search__message--spinner");
  resultHtml = document.querySelector(".search__result-con");
  searchField = document.querySelector(".search__field ");
  phoneHeader = document.querySelector(".wsmobileheader");
  excludeKeys = ["ArrowRight", "ArrowUp", "ArrowLeft", "ArrowDown", "Enter"];

  deafultMessage = `
  <h2 class="search__text--before text-center">
      نتایج جستجو
      <svg class="search__icon">
          <use href="${icon}#icon-search"></use>
      </svg>
  </h2>`;

  successMessage = `
  <h2 class="search__text--after text-center">
    <div class="search__message-">
        <span class="search__result-num">0</span> مورد برای <span class="search__result-text"> ' کلمه سرچ شده ' </span> یافت شد
    </div>
  </h2>`;

  failMessage = `
  <h2 class="search__text--before text-center">
    موردی یافت نشد ☹️
  </h2>`;

  errorMessage = `
  <h2 class="search__text--before text-center">
    مشکلی در جستجو پیش آمده☹️
  </h2>`;

  constructor() {
    if (!this.parentEl) return;

    this.addHandlerOverlayOpen();

    this.addHandlerOverlayClose();
    // for prevent form submit when user press enter
    this.addHandlerSubmit();
  }

  /**
   * @abstract this methode makes search overlay open or close
   * @param {string} atrrBol - aria-expanded situation
   * @param {string} overflowSitu - makes overflow of body hide or scroll
   */
  overlayToggler(atrrBol, overflowSitu) {
    // make aria-expanded flase or true
    this.parentEl.setAttribute("aria-expanded", atrrBol);

    //shows or hides search overlay
    this.parentEl.classList.toggle("search__overlayOpen");

    //render deafult message in field
    this.renderMessage(this.deafultMessage);

    // this makes background scroll enable/disable
    document.querySelector("body").style.overflow = overflowSitu;

    //
    this.clear();
    this.searchInput.value = "";
    this.spinnerCon.classList.add("d-none");

    // in phone view makes menu visible/invisible
    this.phoneHeader.classList.toggle("d-none");
  }

  addHandlerOverlayOpen() {
    window.addEventListener(
      "click",
      function (e) {
        // when user on browser window clicks on search btn
        const btn = e.target.closest(".search__btn");

        // if user dose not click on search btn return
        if (!btn) return;

        //make search overlay visible and set aria-expanded to true
        this.overlayToggler("true", "hidden");

        // fo auto focus on search bar
        setTimeout(() => {
          this.searchInput.focus();
        }, 200);
      }.bind(this)
    );
  }

  addHandlerOverlayClose() {
    // 1) when user press escape btn
    window.addEventListener(
      "keyup",
      function (e) {
        e.preventDefault();
        if (this.parentEl.ariaExpanded === "false") return;

        const btn = e.key;
        if (btn === "Escape") {
          this.overlayToggler("false", "scroll");
        }
      }.bind(this)
    );
    // 2) when user click outside field
    this.parentEl.addEventListener(
      "click",
      function (e) {
        const btn =
          !e.target.closest(".search__field") &&
          !e.target.closest(".search__input--text");

        if (!btn) return;

        this.overlayToggler("false", "scroll");
      }.bind(this)
    );

    // 3) when user clicks on x icon
    window.addEventListener(
      "click",
      function (e) {
        const btn = e.target.closest(".search__icon-background");
        if (!btn) return;
        this.overlayToggler("false", "scroll");
      }.bind(this)
    );
  }

  clear() {
    this.resultHtml.innerHTML = "";
  }

  generateMarkup(data) {
    return data
      .map((postObj, i, arr) => {
        return `
          <div class="search__result-box">
                <div class="search__result-img">
                    <img src=${postObj.featureImg} alt="">
                </div>

                <div class="search__result-des">
                   <a href="${postObj.permalink}">
                       <h5 class="search__result-title">${postObj.title}</h5>
                   </a>

                  <sub class="search__ath"> ${postObj.author}</sub>
                </div>
          </div>
        `;
      })
      .join("");
  }

  render(data) {
    this.spinnerCon.classList.add("d-none");

    // 1) when user deletes search input, dont render anything
    if (!this.searchInput.value.length) {
      // this.searchMessage.classList.remove("d-none");
      return this.renderMessage(this.deafultMessage);
    }

    // 2) if search keyword does not have result
    if (!data.length) {
      // clear search result
      this.clear();
      // render fail message (return is for not countinuing nex step)
      return this.renderMessage(this.failMessage);
    }
    //if search keyword have result
    this.clear();
    this.resultHtml.insertAdjacentHTML("beforeend", this.successMessage);
    this.resultNum = document.querySelector(".search__result-num");
    this.resultMess = document.querySelector(".search__result-text");
    this.resultMess.style.color = "red";
    this.resultHtml.insertAdjacentHTML("beforeend", this.generateMarkup(data));
    this.resultNum.textContent = data.length;
    this.resultMess.textContent = `' ${this.searchInput.value} '`;
  }

  renderSpinner() {
    // this.resultHtml.innerHTML = '<span class="loader"></span>';
    this.spinnerCon.classList.remove("d-none");
    this.spinnerCon.innerHTML = '<span class="loader"></span>';
  }

  renderMessage(message) {
    this.searchMessage.classList.remove("d-none");
    this.searchMessage.innerHTML = message;
  }

  renderError() {
    this.spinnerCon.classList.add("d-none");
    // this.searchMessage.classList.remove("d-none");
    this.renderMessage(this.errorMessage);
  }

  addHandlerKeyPress(handler) {
    if (!this.searchInput) return;

    this.searchInput.addEventListener(
      "keyup",
      function (e) {
        // if user dont pressed exclude keys then render
        if (!this.excludeKeys.includes(e.key)) {
          this.clear();
          this.searchMessage.classList.add("d-none");
          handler(this.searchInput.value);
        }
      }.bind(this)
    );
  }

  // for prevent form submit when user press enter
  addHandlerSubmit() {
    this.parentEl
      .querySelector("form")
      .addEventListener("submit", function (e) {
        e.preventDefault();
      });
  }
}

export default new search();
